import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './EReceptList.module.scss';
import EReceptListItem, { EReceptRow } from './EReceptListItem';
import FlatList from '../../../Modules/Base/Components/FlatList';
import ScrollContainer from '../../../Modules/Base/Components/ScrollContainer';
import usePresecriptions from '../../../Modules/EPrescription/Hooks/usePresecriptions';
import useFlatData from '../../../Modules/Base/Hooks/useFlatData';
import Text from '../../Base/Text/Text';
import { getMomentDate } from '../../../Utils/dates.util';
import useScope from '../../../Modules/Scope/Hooks/useScope';
import P1PrescriptionListItem from '../../../Modules/P1/Components/P1PrescriptionListItem/P1PrescriptionListItem';

interface EReceptListProps {
	patientId: string;
	setIsLoading?: (isLoading: boolean) => void;
}

const wrapperId = 'ePrescriptionsWrapper';

export default function EReceptList(props: EReceptListProps) {
	const { patientId, setIsLoading } = props;
	const { getPrescriptions, getNextPage, data, isLoading, page, setPage } =
		usePresecriptions();
	const [modifiedData, setModifiedData] = useState<EReceptRow[]>([]);
	const { isLatam, isPoland } = useScope();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getPrescriptions,
		{
			data: data?.prescriptions?.data,
			totalPages: data?.prescriptions?.meta?.totalPages,
			page: data?.prescriptions?.meta?.page,
		},
		page,
		setPage,
	);

	useEffect(() => {
		setFilter({
			userId: patientId,
		});
	}, []);

	useEffect(() => {
		const tempData: EReceptRow[] = [];
		let lastDate = '';
		flatData.forEach(item => {
			const date = getMomentDate(item.createdAt).format('YYYY-MM-DD');
			let showDate = false;
			if (date != lastDate) {
				showDate = true;
				lastDate = date;
			}
			tempData.push({ ...item, showDate });
		});
		setModifiedData(tempData);
	}, [flatData]);

	const refreshData = async () => {
		setIsLoading?.(true);
		await loadData();
		setIsLoading?.(false);
	};

	let renderItemComponent = (item: EReceptRow) => (
		<EReceptListItem
			item={item}
			key={item.id}
			patientId={patientId}
			refreshList={refreshData}
		/>
	);

	if (isPoland) {
		renderItemComponent = (item: EReceptRow) => (
			<P1PrescriptionListItem item={item} onDelete={refreshData} />
		);
	}

	return (
		<div className={styles.wrapper}>
			{isLatam && (
				<div className={styles.header}>
					<Text
						className={styles.date}
						tx='component.eReceptList.header.date'
					/>
					<Text
						className={styles.medicament}
						tx='component.eReceptList.header.medicament'
					/>
					<Text
						className={styles.validityDate}
						tx='component.eReceptList.header.validityDate'
					/>
				</div>
			)}
			{/*<div className={styles.options}>*/}
			{/*    <Checkbox tx={'Vše'}/>*/}
			{/*    <PrintButton onClick={handlePrint}/>*/}
			{/*    <ExportButton onClick={handleExport}/>*/}
			{/*</div>*/}
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={modifiedData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={renderItemComponent}
				/>
			</ScrollContainer>
			{/*<NoDataPlaceholder tx={'base.patientHasNoElectronicPrescription'} />*/}
		</div>
	);
}
